import { Component, Input, OnInit } from '@angular/core';
import { DateUtil } from '../../utils/date.util';
import moment from 'app/moment.override';
import { DailyChartService } from 'app/services/rszoft/dailychart/daily-chart.service';
import { TableDay, TableWeek } from 'app/services/rszoft/dailychart/models/table.model';
import { TabOption } from 'app/services/rszoft/report.model';

@Component({
    selector: 'app-weekly-table',
    templateUrl: './weekly-table.component.html',
    styleUrls: ['./weekly-table.component.css']
})
export class WeeklyTableComponent implements OnInit {
    @Input() weeklyData: TableWeek;
    @Input() selectedTab: TabOption;
    @Input() lastDownloadDate: number;
    @Input() timezone: string;
    @Input() isPrint = false;

    driverDisplayColumns = ['date', 'startDate', 'endDate', 'driving', 'working', 'availability', 'allWorksInDay', 'vehicle'];
    vehicleDisplayColumns = ['date', 'startDate', 'endDate', 'driving', 'cardlessDrivingFromActivities', 'kmRange', 'kmSum', 'avgSpeed', 'driver', 'fault'];
    tabOptions = TabOption;
    _moment = moment;
    dateUtil = DateUtil;
    math = Math;

    constructor(public dailyChartService: DailyChartService) {}

    ngOnInit(): void {}

    isFinal(): boolean {
        return this.weeklyData?.days?.length > 0 && this.weeklyData.days[this.weeklyData.days.length - 1].recordDate * 1000 + 1439 < this.lastDownloadDate;
    }

    getUniqueFaultLabels(dailyData: TableDay): string[] {
        const labels: string[] = [];
        const seenLabels = new Set<string>();
        (dailyData?.faults || []).forEach(fault => {
            if (fault.eventFaultType === undefined || fault.eventFaultType === null) {
                return;
            }
            const label = 'Report.WeeklyTable.FaultCode.' + fault.eventFaultType;
            if (!seenLabels.has(label)) {
                seenLabels.add(label);
                labels.push(label);
            }
        });
        if ((dailyData?.cardlessDrivingFromActivities || 0) > 0) {
            // Same event type as a recorded "driving without an appropriate card" event, so it is
            // only added when that event is not already present on the day.
            const cardlessLabel = 'Report.WeeklyTable.FaultCode.4';
            if (!seenLabels.has(cardlessLabel)) {
                seenLabels.add(cardlessLabel);
                labels.push(cardlessLabel);
            }
        }
        return labels;
    }

}
